jQuery( document ).ready( function ( $ ) {
	class ANIMATEDCOUNTER {
		constructor( thisInstance ) {
			this.version = '1.1'
			//console.log( '[JTF Gut Block - JS] jtf/jtf-animatedcounter v' + this.version )
			
			this.instance = thisInstance
			this.onFirstLoad()
			this.scrollEvents()
		}
		
		animate( thisCounter ) {
			const suffix = thisCounter.data( 'suffix' ) || ''
			const min = thisCounter.data( 'min' ) || 0
			const max = thisCounter.data( 'max' ) || 100
			const duration = thisCounter.data( 'duration' ) || 2
			thisCounter.addClass( 'jtf__animatedcounter--counter--active' )
			
			const steps = max - min
			if ( steps === 0 ) {
				thisCounter.html( min + suffix )
				return
			}
			
			const intervalTime = (duration * 1000) / steps
			let current = min
			
			let interval = setInterval( () => {
				thisCounter.html( current + suffix )
				current++
				if ( current > max ) {
					clearInterval( interval )
				}
			}, intervalTime )
		}
		
		isInViewport( target ) {
			const rect = target[ 0 ].getBoundingClientRect()
			return (
				rect.top < window.innerHeight &&
				rect.bottom > 0 &&
				rect.left < window.innerWidth &&
				rect.right > 0
			)
		}
		
		onFirstLoad() {
			const self = this
			const thisCounter = self.instance.find( '.jtf__animatedcounter--counter' )
			
			thisCounter.each( function () {
				if ( self.isInViewport( $( this ) ) ) {
					if ( !$( this ).hasClass( 'jtf__animatedcounter--counter--active' ) ) {
						self.animate( $( this ) )
					}
				}
			} )
		}
		
		scrollEvents() {
			const self = this
			const thisCounter = self.instance.find( '.jtf__animatedcounter--counter' )
			
			const scrollHandler = function () {
				thisCounter.each( function () {
					const counter = $( this )
					if ( self.isInViewport( counter ) ) {
						if ( !counter.hasClass( 'jtf__animatedcounter--counter--active' ) ) {
							self.animate( counter )
						}
						//Unmap after all have been animated, we dont need to track scroll events anymore
						if ( thisCounter.filter( ':not(.jtf__animatedcounter--counter--active)' ).length === 0 ) {
							$( window ).off( 'scroll', scrollHandler )
						}
					}
				} )
			}
			
			$( window ).on( 'scroll', scrollHandler )
		}
		
	}
	
	const thisBlock = $( '.wp-block-jtf-jtf-animatedcounter' )
	
	if ( thisBlock.length > 0 ) {
		thisBlock.each(
			function () {
				new ANIMATEDCOUNTER( $( this ) )
			},
		)
	}
} )

